import { Icon } from '@eventbrite/eds-icon';
import { Cross } from '@eventbrite/eds-iconography';
import React, { useEffect, useRef, useState } from 'react';
import { missingInformationString, TaxpayerMissingInformation } from '../types';
import { getSessionStorageOrDefault } from '../utils';
import { getTaxpayerInformation } from './hooks';
import './TooltipNotification.scss';
import withTooltip from './withToolip';

const TooltipContent = withTooltip(({ children }: any) => children);

const STATE_KEY = 'document_request_status_tooltip_seen';

export const TooltipNotification = () => {
    const orgId = window?.__SERVER_DATA__?.activeOrganizationId || '';
    const keyTooltipSeen = `${orgId}_${STATE_KEY}`;
    const tooltip = useRef<any>(null);
    const tooltipNotificationId = `request-taxpayer-tooltip-${orgId}`;
    const missingInformationObject = getTaxpayerInformation(orgId);

    const [title, setTitle] = useState<missingInformationString>('');
    const [subTitle, setSubTitle] = useState<missingInformationString>('');
    const [buttonText, setButtonText] = useState<missingInformationString>('');
    const [buttonLink, setButtonLink] = useState<missingInformationString>('');
    const [tooltipSeen, setTooltipSeen] = useState(
        getSessionStorageOrDefault(keyTooltipSeen, false),
    );

    useEffect(() => {
        const statusData =
            missingInformationObject as TaxpayerMissingInformation;
        if (!tooltipSeen && statusData?.tooltipNotification) {
            setTitle(statusData.message?.titleTooltip);
            setSubTitle(statusData.message?.subTitleTooltip);
            setButtonText(statusData.message?.buttonText);
            setButtonLink(statusData.message?.buttonLink);
            tooltip.current?.show();
        }
    }, [
        orgId,
        missingInformationObject,
        title,
        subTitle,
        buttonLink,
        tooltipSeen,
    ]);

    useEffect(() => {
        sessionStorage.setItem(keyTooltipSeen, JSON.stringify(tooltipSeen));
    }, [tooltipSeen, keyTooltipSeen]);

    const hideOnClick = () => {
        setTooltipSeen(true);
        tooltip.current?.hide();
    };

    const tooltipText = (
        <div
            className="TooltipNotificationDialog"
            onClick={(e) => e.stopPropagation()}
        >
            <h1
                className="eds-text-bm eds-text-weight--heavy eds-text-color--ui-900
            eds-l-mar-bot-2 eds-l-pad-right-3"
            >
                {title}
            </h1>
            <p className="eds-text-bm">{subTitle}</p>
            <a className="eds-text-weight--heavy" href={buttonLink as string}>
                {buttonText}
            </a>
            <a id="hideToolTip" onClick={() => hideOnClick()}>
                <Icon type={<Cross />} />
            </a>
        </div>
    );

    return (
        <TooltipContent
            ref={tooltip}
            tooltipId={tooltipNotificationId}
            tooltipText={tooltipText}
            tooltipArrowLocation={'top'}
            hideTooltipOnMouseLeave={false}
            tooltipStyle="phab"
            keepTooltipOpen={true}
            __containerClassName="TooltipNotification"
        >
            &nbsp;
        </TooltipContent>
    );
};
